import { render, staticRenderFns } from "./BaseInformationMessage.vue?vue&type=template&id=10acc1dd&"
import script from "./BaseInformationMessage.vue?vue&type=script&lang=js&"
export * from "./BaseInformationMessage.vue?vue&type=script&lang=js&"
import style0 from "./BaseInformationMessage.vue?vue&type=style&index=0&id=10acc1dd&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports